import { ToastContent, ToastOptions, toast as reactToastify } from "react-toastify";

export const toast = {
    ...reactToastify,
    info: (content: ToastContent, options?: ToastOptions) => reactToastify.info(content, { hideProgressBar: true, ...options }),
    success: (content: ToastContent, options?: ToastOptions) => reactToastify.success(content, { hideProgressBar: true, ...options }),
    warning: (content: ToastContent, options?: ToastOptions) => reactToastify.warning(content, { hideProgressBar: true, ...options }),
    error: (content: ToastContent, options?: ToastOptions) => reactToastify.error(content, { hideProgressBar: true, ...options }),
};
